import React, { useEffect, useState } from 'react';
import { Button, Container, Row, Col, Modal } from 'react-bootstrap';
import StageModal from './StageModal';
import EditIcon from '@mui/icons-material/Edit';
import IconButton from '@mui/material/IconButton';
import { PostData } from '../API/postApi';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { selectStatus, selectUser, SetStatusSelected } from '../ReduxStore/userReducer';
import { PostCrmStage } from '../API/API';
import SunspotLoader from '../sharedFiles/loader/loader';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import dayjs from 'dayjs';
import CommonDynamicTable from '../sharedFiles/CommonDynamicTable/CommonDynamicTable';
import { postCrmStatus } from '../API/API';
import {
    Box,

    FormControl,
    FormControlLabel, FormLabel,
    InputLabel,
    MenuItem,
    Paper,
    Radio, RadioGroup,
    Select,
    Table,
    TableContainer,
    TableHead, TableRow,
    TableBody, TableCell,
    TextField
} from '@mui/material';
import { useOutsideAlerter } from '../sharedFiles/dropdownCloser/dropdownCloser';
import { showSubmitConfirmation } from '../sharedFiles/ConfirmationModel/confirmationModel';



const FollowupTable = ({ setNewStage, newStage, setShowModal, showModal, setMode, mode,
    setEditMode, editMode, setIsStageSubmitted, isStageSubmitted, stageMaster, prevdata
    , OpportunityId, fetchData, setLoading, opprStatuses,handleBackNav
    // , setLostDocValue, lostDocValue 
}) => {
    const userData = useSelector(selectUser);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const jwtToken = userData?.JwtToken;
    const DatabaseName = userData?.DatabaseName;
    const [opendates, setOpendate] = useState(dayjs());
    const [closedates, setClosedate] = useState(dayjs());
    const [nextDate, setNextDate] = useState(dayjs());
    const [nextCloseDate, setNextCloseDate] = useState(dayjs());
    const selectedStatus = useSelector(selectStatus);
    const [stages, setStages] = useState([]);
    const [tbodyStages, setTbodyStages] = useState([]);
    const [showLostModal, setShowLostModal] = useState(false);
    const [show, setshow] = useState(false);
    const lastLineId = stages.length > 0 ? stages[stages.length - 1].id : 0;
    const potentialAmount = stages.length > 0 ? stages[stages.length - 1].potentialAmount : 0;
    const wrapperRef = React.useRef(null);
    const tableHeader = ["document_Number", "document_Name", "total_Quantity"]
    const [documents, setDocuments] = useState([]);
    const [isDisabled, setIsDisabled] = useState(false);
    const [progress, setProgress] = useState(0)

    useOutsideAlerter(wrapperRef, () => setshow(false));
    const fetchStages = () => {
        const formattedStages = prevdata.map(stage => {
            // Update the openDate if it's valid and set it to state
            if (dayjs(stage.openDate).isValid()) {
                setOpendate(dayjs(stage.openDate));
            }
            if (dayjs(stage.closedate).isValid()) {
                setClosedate(dayjs(stage.closedate));
            }

            return {
                id: stage.lineId,
                openDate: dayjs(stage.openDate).isValid()
                    ? dayjs(stage.openDate).format('DD/MM/YYYY')
                    : null,
                closingDate: dayjs(stage.closedate).format('DD/MM/YYYY'),
                stage: stage.descript,
                stageId: stage.stageId,
                percentage: stage.closePrcnt,
                remarks: stage.remarks || '',
                comments: stage.u_Comments || '',
                status: stage.status,
                nextStage: '',
                nextStartDate: '',
                nextCloseDate: '',
                nextStageId: 0,
                potentialAmount: stage.potentialAmount || 0,
            };
        });

        setStages(formattedStages);
    };

    useEffect(() => {
        fetchStages();
    }, [prevdata]);

    useEffect(() => {
        const formattedStages = stages.map(stage => {
            return {
                id: stage.id,
                openDate: stage.openDate || stage.nextStartDate,
                closingDate: stage.closingDate || stage.nextCloseDate,
                stage: stage.stage || stage.nextStage,
                stageId: stage.stageId || stage.nextStageId,
                percentage: stage.percentage,
                remarks: stage.remarks || '',
                comments: stage.comments || '',
                status: stage.status,
                potentialAmount: stage.potentialAmount || 0,
            };
        });

        setTbodyStages(formattedStages); // Update tbodyStages whenever stages change
    }, [stages]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setNewStage(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleAddStage = () => {
        if (!newStage.stage || !newStage.percentage) {
            alert("Error: Stage and Percentage are required.");
            return;
        }


        const updatedStages = [...stages];
        if (!editMode) {
            const stageData = {
                ...newStage,
                id: lastLineId + 1,
                potentialAmount: potentialAmount,
                nextStageId: newStage.nextStageId,
                nextStartDate: newStage.nextStartDate,
                // nextStartDate: nextDate.format('DD/MM/YYYY'),
                status: 'O',
            };
            updatedStages.push(stageData);
        } else {
            const index = updatedStages.findIndex(stage => stage.id === newStage.id);
            if (index !== -1) {
                updatedStages[index] = newStage;
            }
        }

        setStages(updatedStages);
        setIsStageSubmitted(true);
        setShowModal(false);
    };

    const handleEditStage = (id) => {
        const stageExistsInPrevData = prevdata.some(stage => stage.lineId === id);
        setEditMode(true);
        if (!stageExistsInPrevData) {
            setMode(false);

            const stageToEdit = stages.find(stage => stage.id === id);
            if (stageToEdit && stageToEdit.status === 'O') {
                setNewStage({ ...stageToEdit });
                setShowModal(true);
                setIsStageSubmitted(false);
            }
        } else {

            const stageToEdit = stages.find(stage => stage.id === id);
            if (stageToEdit && stageToEdit.status === 'O') {
                setNewStage({ ...stageToEdit });
                setShowModal(true);
                setMode(true);
                // setEditMode(false);
            }

        }
    };
    const handleGoBack = () => {
        // window.history.back();
        navigate("/CustomerFollowups")
    };

    const handleFinalClose = () => {
        setShowLostModal(false);
    }
    
    const handleFinalSubmit = () => {
        const hasEmptyDescrip = opprStatuses.some(
            (item) =>
              item.status === "Lost" && (
                !item.Descrip ||
                !item.Descrip.name ||
                item.Descrip.name.trim() === ""
              )
          );
          if (hasEmptyDescrip) {
            toast.warning("Please select a Reason before submitting.", {
              position: "bottom-right",
              theme: "dark",
            });
            return; 
          }

          const isBilledOtherLedgerInvalid = opprStatuses.some(
            (item) => 
                item.status === "Lost" &&
                // item.Descrip.name === "BILLED OTHER LEDGER" &&
                item.Descrip.name === "BILLED-LEDGER CHANGE" &&
                // (!item.docNum || item.docNum === null || item.docNum.trim() === "")
                (!item.docNum || 
                    (typeof item.docNum === 'string' && item.docNum.trim() === "") || // for strings, check if it's empty
                    (typeof item.docNum !== 'string' && item.docNum == null)) // for non-strings, check if it's null or undefined
           
        );
    
        if (isBilledOtherLedgerInvalid) {
            toast.warning("Please select a DocNum when Reason is 'BILLED OTHER LEDGER'.", {
                position: "bottom-right",
                theme: "dark",
            });
            return;
        }
        const isL1 = userData.AccessLevel === 'L1';
        const shouldTriggerLostFlow = opprStatuses.some(
            status => status.status === 'Lost' && status.documentsToClose?.length > 0 && isL1
        );
        if (shouldTriggerLostFlow) {
            const lostStatus = opprStatuses.find(status => status.status === 'Lost' && status.documentsToClose?.length > 0);
            if (lostStatus) {
                triggerLostFlow(lostStatus.documentsToClose);
                return; 
            }
        }
    
        handleSubmit();
    };
    const triggerLostFlow = (documents) => {
        setDocuments(documents);
        setShowLostModal(true);
        setIsDisabled(true);
        setProgress(0);
    
        const interval = setInterval(() => {
            setProgress(prev => {
                if (prev >= 100) {
                    clearInterval(interval);
                    setIsDisabled(false);
                    return 100;
                }
                return prev + 20;
            });
        }, 1000);
    };
    
    const handleSubmit = async () => {
        showSubmitConfirmation(async () => {
            setLoading(true);
            try {
                const today = dayjs().format('YYYY-MM-DD');
                const stageModals = stages
                    .filter(stage => stage.status === "O")
                    .map(stage => {
                        const openDate = dayjs(opendates).format('YYYY-MM-DD');
                        const closeDate = dayjs(closedates).format('YYYY-MM-DD');
                        const nxtOpenDate = dayjs(nextDate).format('YYYY-MM-DD');
                        const nxtCloseDate = dayjs(nextCloseDate).format('YYYY-MM-DD');

                        return {
                            stageId: stage.stageId,
                            lineId: stage.id,
                            openDate,
                            closeDate,
                            remarks: stage.remarks,
                            comments: stage.comments,
                            nxtStageId: stage.nextStageId,
                            nxtOpenDate,
                            nxtCloseDate,
                            potentialAmount: stage.potentialAmount || 0,
                        };
                    });

                const payload = {
                    opportunityId: OpportunityId,
                    stageModals,
                    dbName: DatabaseName,
                };
                const response = await PostData(PostCrmStage, payload, jwtToken, dispatch, navigate);
                if (response === "OK") {
                    setIsStageSubmitted(true);
                    if (selectedStatus) {
                        const updatedOpprStatuses = opprStatuses.map(status => {
                            if (status.status === 'Open' ) {
                                return {
                                    ...status,
                                    documentsToClose: [],
                                    Descrip: "",
                                    decripId: 0,
                                    lostRemarks: "",
                                };
                            } 
                            if (typeof status.Descrip === 'object' && status.Descrip.name) {
                                return {
                                    ...status,
                                    Descrip: status.Descrip.name
                                };
                            }

                            return status;
                        });
                        const stageInp = {
                            opportunityId: OpportunityId,
                            opprStatuses: updatedOpprStatuses,
                            dbName: DatabaseName,
                            accesslevel: userData.AccessLevel,
                        };
                        const postStatus = await PostData(postCrmStatus, stageInp, jwtToken, dispatch, navigate);
                        if (postStatus === "OK") {
                            toast.success("Submitted Successfully", {
                                position: "bottom-right",
                                theme: "dark",
                            });
                            dispatch(SetStatusSelected(false));
                            setShowLostModal(false);
                            await fetchData();
                            // setLostDocValue(false);
                        } else {
                            toast.error(postStatus, {
                                position: "bottom-right",
                                theme: "dark",
                            });
                        }
                    } else {
                        toast.success("Submitted Successfully", {
                            position: "bottom-right",
                            theme: "dark",
                        });
                
                    }
                    
                } else {
                    toast.error(response, {
                        position: "bottom-right",
                        theme: "dark",
                    });

                }
            } catch (error) {
                toast.error(error.message || "Submission failed", {
                    position: "bottom-right",
                    theme: "dark",
                });

            } finally {
                setLoading(false);
                // await fetchData();
            }
        });
    };

    const handleShow = () => {
        setshow(true);
    }
    const formatHeader = (header) => {
        return header
            .replace(/_/g, " ") // Replace underscores with spaces
            .replace(/\b\w/g, (char) => char.toUpperCase()); // Capitalize first letter of each word
    };

    return (
        <div className='stagesoppTable'>
            <div className="opportable table-border stagesTable">
                <CommonDynamicTable
                    data={tbodyStages}
                    onEditRow={handleEditStage}
                    showEditButton={stages.some(stage => stage.status === 'O')}
                    dataType={"OppStage"}
                />
            </div>
            <StageModal
                showModal={showModal}
                handleClose={() => setShowModal(false)}
                newStage={newStage}
                handleInputChange={handleInputChange}
                handleAddStage={handleAddStage}
                setnewStage={setNewStage}
                handleEditStage={handleEditStage}
                stageMaster={stageMaster}
                mode={mode}
                prevData={prevdata}
                editMode={editMode}
                setNextDate={setNextDate}
                setOpendate={setOpendate}
                setClosedate={setClosedate}
                setNextCloseDate={setNextCloseDate}
                isStageSubmitted={isStageSubmitted}
            />
            <Modal show={showLostModal} onHide={handleFinalClose} className="crmstage-modal" centered>
                <div className="crmmodal-content">
                    <div className="crmmodal-header">
                        <Button variant="close" onClick={handleFinalClose} />
                    </div>
                    <div className="crmmodal-body">
                        <TableContainer component={Paper}>
                            <Table>
                                {/* Table Head */}
                                <TableHead>
                                    <TableRow>
                                        {tableHeader.map((header) => (
                                            <TableCell key={header} style={{ backgroundColor: "#182e59", color: "white", fontWeight: "bold" }}>
                                                {formatHeader(header)}
                                            </TableCell>
                                        ))}
                                    </TableRow>
                                </TableHead>

                                {/* Table Body */}
                                <TableBody>
                                    {documents && documents.map((row, index) => (
                                        <TableRow key={index}>
                                            {/* {console.log("row :", row)} */}
                                            {tableHeader.map((header) => (
                                                <TableCell key={header}>{row[header]}</TableCell>
                                            ))}
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        <p className='text-danger fs-6'>{formatHeader("To Finalize The Closure of documents press submit!")}</p>
                    </div>
                    <div className="crmmodal-footer">
                        {/* <Button onClick={handleSubmit} style={{ backgroundColor: "#182e59", color: "white" }}>
                            Submit
                        </Button> */}
                        <Button
                            onClick={handleSubmit}
                            disabled={isDisabled}
                            style={{
                                position: "relative",
                                cursor: isDisabled ? "not-allowed" : "pointer",
                                background: `linear-gradient(to right, #182e59 ${progress}%, #ccc ${progress}%)`, // Dynamic fill
                                color: "#fff",
                                border: "none",
                                width: "100px",
                                borderRadius: "5px",
                                transition: "background 0.3s ease",
                            }}
                        >
                            {isDisabled ? "Loading..." : "Submit"}
                        </Button>
                    </div>
                </div>
            </Modal>
            <div className="bsbutton">
                <Button
                    variant="outline-primary"
                    onClick={handleBackNav}
                    size="sm"
                    style={{ marginRight: '10px' }} // Space between buttons
                >
                    Back
                </Button>

                <Button
                    className='btnsubmitt'
                    variant="success"
                    onClick={handleFinalSubmit}
                    // onClick={handleSubmit}
                    size="sm"
                >
                    Submit
                </Button>
            </div>
            {/* <ToastContainer /> */}
            {/* {isLoading && (
                <div className="loader position-absolute">
                    <SunspotLoader />
                </div>
            )} */}
        </div>
    );
};

export default FollowupTable;
